import { Component, OnInit, Input, QueryList, ViewChildren } from '@angular/core';
import { DatePipe } from '@angular/common';

import { DatatableComponent, DataTableColumnDirective } from '@swimlane/ngx-datatable';

import { ShowSettingServiceService } from '../../services/show-setting-service.service';
import { ShowCondition, getSelectConditionIdentity, ControlModelPropertyEnum, ControlTypeName } from '../../types';
import { OptionService } from '../../services/option.service';

@Component({
  selector: 'df-ngx-data-table-dynamic',
  templateUrl: './ngx-data-table-dynamic.component.html',
  styleUrls: ['./ngx-data-table-dynamic.component.css'],
  providers: [DatePipe]
})
export class NgxDataTableDynamicComponent implements OnInit {
  @Input() formCode: string;
  @Input() ngxDatatable: DatatableComponent;
  @Input() beforeColumnName: string;
  @Input() dateFormate?: string = 'yyyy-MM-dd HH:mm:ss';

  @ViewChildren(DataTableColumnDirective)
  set columnTemplates(val: QueryList<DataTableColumnDirective>) {
    this._columnTemplates = val;
  }

  get columnTemplates(): QueryList<DataTableColumnDirective> {
    return this._columnTemplates;
  }

  showConditions: Array<ShowCondition> = [];
  dataTableColumns: Array<any> = [];

  optionCaches: Array<ShowConditionOptionCache> = []; // éé¡¹ç¼å­

  private _columnTemplates: QueryList<DataTableColumnDirective>;

  constructor(
    private showSettingServiceService: ShowSettingServiceService,
    private optionService: OptionService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.loadForm();
  }

  loadForm() {
    this.showSettingServiceService.getCondition(this.formCode).subscribe((s) => {
      this.showConditions = s.showCondition;
      this.resetColumn(s.showCondition);
    });
  }

  /**
   * éç½®å±ç¤ºå
   *
   * @param showConditions
   * @memberof NgxDataTableDynamicComponent
   */
  resetColumn(showConditions: Array<ShowCondition>) {
    showConditions = showConditions.sort((a, b) => {
      return a.serialNo - b.serialNo;
    });
    showConditions.forEach((s) => {
      if (s.multiDataAttrCode && s.multiDataAttrCode.length > 0) {
        s.multiDataAttrCode.forEach((r) => {
          const column = {
            dataEntityCode: s.dataEntityCode,
            dataAttrCode: r.name,
            type: r.dataType,
            name: r.caption,
            prop: getSelectConditionIdentity({ dataEntityCode: s.dataEntityCode, dataAttrCode: r.name }),
            sortable: true,
            draggable: true,
            canAutoResize: true,
            minWidth: 30,
            width: 80,
            // maxWidth: 100,
            headerClass: 'header',
            cellClass: 'cell'
          };
          this.dataTableColumns.push(column);
        });
      } else if (s.dataAttrCode) {
        const column = {
          dataEntityCode: s.dataEntityCode,
          dataAttrCode: s.dataAttrCode,
          type: s.type,
          name: s.caption,
          prop: getSelectConditionIdentity(s),
          sortable: true,
          draggable: true,
          canAutoResize: true,
          minWidth: 30,
          width: 80,
          // maxWidth: 100,
          headerClass: 'header',
          cellClass: 'cell'
        };
        this.dataTableColumns.push(column);
      }
    });
    setTimeout(() => {
      const newColumns = this.getNewColumns();
      this.ngxDatatable.columnTemplates.reset(newColumns);
      this.ngxDatatable.columnTemplates = this.ngxDatatable.columnTemplates;
    }, 0);
  }

  /**
   * è·åææ¬åå®¹
   *
   * @param row
   * @param item
   * @memberof NgxDataTableDynamicComponent
   */
  getContent(row: any, item: any) {
    // è¦å¤æ­ç©ºï¼ï¼
    if (!row.dynamicFields) return '';
    if (!row.dynamicFields[item.dataEntityCode]) return '';

    const value = row.dynamicFields[item.dataEntityCode][item.dataAttrCode];
    // æ®éçç´æ¥è¿åå¼
    // å¦ææ¯æéé¡¹çï¼åéè¦éæ°è·åå¼
    const condition = this.showConditions.find(
      (s) =>
        getSelectConditionIdentity(s) === getSelectConditionIdentity(item) &&
        !!s.model &&
        !!s.model[ControlModelPropertyEnum.Option]
    );

    if (!condition) {
      if (!item.type) {
        return value;
      }
      if (item.type.toLowerCase() === 'datetime') {
        if (value) {
          return this.datePipe.transform(value, this.dateFormate);
        }
      }
      return value;
    }
    let cache = this.optionCaches.find((p) => p.identity === getSelectConditionIdentity(condition));
    if (!cache) {
      cache = {
        identity: getSelectConditionIdentity(condition),
        isFirst: false,
        value: []
      };
      this.optionCaches.push(cache);
    }

    if (!cache.isFirst) {
      cache.isFirst = true;
      // ä»ç¼å­ä¸­è·åæ°æ®å¹¶è¿å
      const option = condition.model[ControlModelPropertyEnum.Option];
      this.optionService.getSelectOptionsByDefaultVarValue(option).subscribe((s) => {
        cache.value = s;
      });
      return '';
    }

    if (condition.type.toLowerCase() === ControlTypeName.multiCheckBox.toLowerCase()) {
      // æ ¹æ®å¼æ¥éåï¼é¿ååå°å¤ä¸ªéå¤å¼
      const multiValue: Array<string> = [];
      if (!value) {
        return value;
      }
      const valueArray = JSON.parse(value);
      if (valueArray instanceof Array) {
        valueArray.forEach((s) => {
          const textValue = cache.value.find((p) => p.id === s);
          if (textValue) {
            multiValue.push(textValue.text);
          }
        });
        return multiValue.toString();
      }
      return '';
    }

    const optionValue = cache.value.find((s) => s.id === value);
    if (optionValue) {
      return optionValue.text;
    } else {
      return '';
    }
  }

  /**
   * è·åæ¡ä»¶æ è¯
   *
   * @memberof NgxDataTableDynamicComponent
   */
  getIdentity(condition: { dataEntityCode: string; dataAttrCode: string }): string {
    return getSelectConditionIdentity(condition);
  }

  /**
   * è·åæ°å
   *
   * @memberof NgxDataTableDynamicComponent
   */
  private getNewColumns(): Array<DataTableColumnDirective> {
    const columns = this.ngxDatatable.columnTemplates.toArray();

    const newColumns: Array<DataTableColumnDirective> = [];
    if (this.beforeColumnName) {
      const index = columns.findIndex((s) => s.name === this.beforeColumnName);
      if (index !== -1) {
        newColumns.push(...columns.slice(0, index));
        newColumns.push(...this.columnTemplates.toArray());
        newColumns.push(...columns.slice(index, columns.length));
        return newColumns;
      }
    }
    newColumns.push(...columns);
    newColumns.push(...this.columnTemplates.toArray());
    return newColumns;
  }
}

/**
 * æ¾ç¤ºæ¡ä»¶éé¡¹ç¼å­
 *
 * @export
 */
export class ShowConditionOptionCache {
  identity: string;
  value: Array<{ id: string; text: string }>;
  isFirst: boolean;
}
